import React from 'react';
import AppsBanner from '../../Shared/AppsBanner/AppsBanner';
import Bg from '../../../Assets/Backgrounds/macBanner.webp';
import {ReactComponent as Btn1} from '../../../Assets/Icons/mac1.svg';

const Banner=()=>{
    return(
        <>
        <AppsBanner
        title="Everything you need to bring ideas to life"
        backgroundImage = {Bg}
        btn1 = {<Btn1 />}
        />
        </>
    )
};
export default Banner ;